/**
 * Checks if an email body HTML string is empty, ignoring the signature.
 * Returns true if the body contains no user-written content beyond the signature.
 */
const isEmailBodyEmpty = (body: string, signatureText?: string): boolean => {
  if (!body) {
    return true;
  }

  const withoutSignature = signatureText ? body.replace(signatureText, "") : body;
  const textContent = new DOMParser().parseFromString(withoutSignature, "text/html").body
    .textContent;

  return !textContent?.trim();
};

export default isEmailBodyEmpty;
